import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React, { Suspense, lazy } from 'react';
import Favicon from 'react-favicon';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Helmet } from 'react-helmet';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import './App.css';
import LazyErrorBoundary from './LazyErrorBoundary';
import WithAxios from './WithAxios';
import Login from './components/Login';
import Recuperar from './components/Recuperar';
import SpinnerFallback from './components/SpinnerFallback';
import WhatsAppButton from './components/WhatsAppButton';
import { CONFIG } from './constants';
import { EmpresaProvider } from './context/empresa-context';
import { SessionProvider } from './context/session-context';
import { UserProvider } from './context/user-context';
import { WhatsAppProvider } from './context/whatsapp-context';

const MainApp = lazy(() => import('./MainApp'));
const LandingSegu = lazy(() => import('./modelos/cotizaciones/LandingSegu'));

const queryClient = new QueryClient();

// const MenuComponent = () => {
//   const { productos, updateProducto } = useContext(EmpresaContext);
//   const {
//     params: { item }
//   } = useRouteMatch();
//   const getLink = (producto) => {
//     const find = TIPOS_PRODUCTOS.find(
//       ({ codigo }) => codigo === producto.codigo
//     );
//     return find ? find.link : '/';
//   };

//   return (
//     <>
//       <Tabs defaultActiveKey={item} centered>
//         {productos.map((producto, index) => (
//           <Tabs.TabPane
//             key={`${getLink(producto)}`}
//             tab={
//               <Link
//                 to={`/${getLink(producto)}`}
//                 onClick={() => updateProducto(producto.id)}
//               >
//                 <span>
//                   {Number(producto.codigo) === 1 && (
//                     <CarOutlined style={{ fontSize: 20 }} />
//                   )}
//                   {Number(producto.codigo) === 2 && (
//                     <UserOutlined style={{ fontSize: 20 }} />
//                   )}
//                   {Number(producto.codigo) === 3 && (
//                     <HeartOutlined style={{ fontSize: 20 }} />
//                   )}
//                   {Number(producto.codigo) === 4 && (
//                     <HomeOutlined style={{ fontSize: 20 }} />
//                   )}
//                   {Number(producto.codigo) === 5 && (
//                     <ShopOutlined style={{ fontSize: 20 }} />
//                   )}
//                   {producto.descripcion}
//                 </span>
//               </Link>
//             }
//           />
//         ))}
//       </Tabs>
//     </>
//   );
// };

const App = () => {
  if (window.location.pathname.startsWith('/cert/')) {
    const id = window.location.pathname.split('/')[2];
    if (window.location.hostname === 'localhost') {
      window.location.href = `http://localhost:8080/api/v1/form/certificado?token=${id}`;
    } else {
      window.location.href = `https:${CONFIG.URL_BASE}/form/certificado?token=${id}`;
    }
    return null;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={CONFIG.RECAPTCHA_KEY}
      language="es-419"
      useRecaptchaNet
    >
      <Favicon url={`/${CONFIG.FAVICON}.ico`} />

      <Helmet>
        <meta charSet="utf-8" />
        <title>{CONFIG.TITULO}</title>
        <meta
          name="msapplication-TileImage"
          content={`${CONFIG.URL_WEB}/${CONFIG.LOGO_300x300}`}
        />
        <meta property="og:site_name" content={CONFIG.TITULO_CORTO} />
        <meta property="og:title" content={CONFIG.TITULO_CORTO} />
        <meta
          property="og:description"
          content="Ingresá al sitio para ver todas las opciones disponibles"
        />
        <meta
          property="og:image"
          itemProp="image"
          content={`${CONFIG.URL_WEB}/${CONFIG.LOGO_300x300}`}
        />
        <meta property="og:url" content={CONFIG.URL_WEB} />
        <link rel="canonical" href={CONFIG.URL_WEB} />
      </Helmet>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <EmpresaProvider>
          <WhatsAppProvider>
            <UserProvider>
              <SessionProvider>
                <Router>
                  <WithAxios>
                    <LazyErrorBoundary>
                      <Suspense fallback={<SpinnerFallback />}>
                        <Switch>
                          <Route
                            exact
                            path="/login"
                            component={() => <Login />}
                          />
                          <Route
                            exact
                            path="/carta-verde"
                            component={() => <LandingSegu />}
                          />
                          <Route
                            exact
                            path="/canal"
                            component={() => <LandingSegu />}
                          />
                          <Route
                            exact
                            path="/recuperar/:token?"
                            component={() => <Recuperar />}
                          />
                          <Route path="*" component={() => <MainApp />} />
                        </Switch>
                      </Suspense>
                    </LazyErrorBoundary>
                    <Route
                      path="/"
                      component={() => <WhatsAppButton text={CONFIG.TITULO} />}
                    />
                  </WithAxios>
                </Router>
              </SessionProvider>
            </UserProvider>
          </WhatsAppProvider>
        </EmpresaProvider>
      </QueryClientProvider>
    </GoogleReCaptchaProvider>
  );
};

export default App;
